import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  limit,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { getAuthUserId, getAuthUserName } from "../utils/auth.util";
import { db } from "../firebase-config/firebase";
import { getCurrentTimestamp } from "../utils/timestamp.util";

class MessagesService {
  async loadConversations(
    callBack: any,
    loadingCallback: any,
    conversationsLocal: any
  ) {
    try {
      conversationsLocal();
      loadingCallback();
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const loggedInUserId = getAuthUserId();
      console.log(loggedInUserId, "loggedInUserId for Rooms");
      const queryRes: any = query(
        collection(db, "conversations"),
        where("participants", "array-contains", loggedInUserId)
      );
      onSnapshot(queryRes, async (rows: any) => {
        if (rows.size > 0) {
          const finalRetArr = [];
          for (const row of rows.docs) {
            finalRetArr.push({
              id: row.id,
              ...row.data(),
              recentMsg: "",
            });
          }
          const sortByrecent = finalRetArr.sort(
            (a, b) => b.lastMessagedAt - a.lastMessagedAt
          );
          callBack(sortByrecent);
        } else {
          callBack([]);
        }
      });
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async checkConversation(userId: string) {
    try {
      const loggedInUserId = getAuthUserId();
      const queryRes: any = query(
        collection(db, "conversations"),
        where("participants", "array-contains", loggedInUserId)
      );
      const resp = await getDocs(queryRes);
      let retConvId = null;
      resp.docs.forEach((doc: any) => {
        if (doc.data().participants.includes(userId)) {
          retConvId = doc.id;
        }
      });
      return retConvId;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async createConversation(
    userId: any,
    userName: any,
    image: any,
    loggedInUserImg: any
  ) {
    try {
      const loggedInUserId = getAuthUserId();
      const conversationsRef = await addDoc(collection(db, "conversations"), {
        participants: [userId, loggedInUserId],
        users: {
          [userId]: userName,
          [loggedInUserId]: getAuthUserName() ?? "",
        },
        lastMessage: "",
        lastMessagedAt: getCurrentTimestamp(),
        lastMessageCount: 0,
        messagedBy: loggedInUserId,
        [`profile_${userId}`]: image,
        [`profile_${loggedInUserId}`]: loggedInUserImg,
      });
      return conversationsRef.id;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async makeUserStatusTyping(convId: any, status: any) {
    try {
      const loggedInUserId = getAuthUserId();
      await updateDoc(doc(db, "conversations", convId), {
        [`typingStatus${loggedInUserId}`]: status,
      });
      return true;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async getConversationMessages(conversationId: string, callBack: any) {
    try {
      const loggedInUserId = getAuthUserId();
      if (!conversationId) {
        return;
      }

      const buildQuery = query(
        collection(db, "conversations", conversationId, "messages"),
        orderBy("createdAt", "asc")
      );
      return onSnapshot(buildQuery, async (res: any) => {
        const lastMessage = res.docs[res.docs.length - 1].data(); // get last message
        if (lastMessage?.user?._id !== loggedInUserId) {
          // if last message not sent by current logged in user
          await updateDoc(doc(db, "conversations", conversationId), {
            lastMessageCount: 0,
          });
        }
        callBack(
          res.size > 0
            ? res.docs.map((d: any) => ({ id: d.id, ...d.data() }))
            : []
        );
      });
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async addMessage(conversationId: string, data: any) {
    try {
      const loggedInUserId = getAuthUserId();
      await updateDoc(doc(db, "conversations", conversationId), {
        lastMessage: data.text,
        lastMessagedAt: getCurrentTimestamp(),
        lastMessageCount: increment(1),
        messagedBy: loggedInUserId,
      });
      await addDoc(
        collection(db, "conversations", conversationId, "messages"),
        {
          ...data,
          user: { _id: loggedInUserId },
          createdAt: getCurrentTimestamp(),
        }
      );
      return true;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async getConversation(conversationId: string) {
    try {
      if (!conversationId) {
        return null;
      }
      const resp: any = await getDoc(doc(db, "conversations", conversationId));
      return resp.exists() ? { id: resp.id, ...resp.data() } : null;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async getConversationOnSnap(conversationId: any, callBack: any) {
    try {
      if (!conversationId) {
        return null;
      }
      const buildQuery = doc(db, "conversations", conversationId);
      return onSnapshot(buildQuery, callBack);
      // const resp: any = await getDoc(doc(db, "conversations", conversationId));
      // return resp.exists() ? { id: resp.id, ...resp.data() } : null;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async getRecentConversationMessage(conversationId: string) {
    try {
      const getQuery = query(
        collection(db, "conversations", conversationId, "messages"),
        orderBy("createdAt", "desc"),
        limit(1)
      );

      let recentMessage = null;
      const resp: any = await getDocs(getQuery);
      if (!resp.empty) {
        const recentMessageData = resp.docs[0].data();
        recentMessage = recentMessageData;
      }
      return recentMessage;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async updateUserProfileImage(profile: any) {
    try {
      const loggedInUserId = getAuthUserId();
      const queryRes: any = query(
        collection(db, "conversations"),
        where("participants", "array-contains", loggedInUserId)
      );
      const resp: any = await getDocs(queryRes);
      for (const res of resp.docs) {
        await updateDoc(doc(db, "conversations", res.id), {
          [`profile_${loggedInUserId}`]: profile,
        });
      }

      return true;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }

  async updateUserProfileName(name: any) {
    try {
      const loggedInUserId = getAuthUserId();
      const queryRes: any = query(
        collection(db, "conversations"),
        where("participants", "array-contains", loggedInUserId)
      );
      const resp: any = await getDocs(queryRes);
      for (const res of resp.docs) {
        await updateDoc(doc(db, "conversations", res.id), {
          users: {
            ...res.data().users,
            [loggedInUserId]: name,
          },
        });
      }

      return true;
    } catch (error: any) {
      throw new Error("Error: " + error.message);
    }
  }
}

export default new MessagesService();
